module.exports = __webpack_public_path__ + "static/media/datasets.6e1a1979.png";